import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class BalancesAndBoltonsService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web de obtener datos relacionados a los saldos
   * Autor: Angel Marin
   * @param msisdn identificador de la cuenta
   * @param suscriptionType identificador de la cuenta
   * @param planId identificador de la cuenta
   * @return Mensaje de confirmación de la validación
   */
  getBalancesAndBolton(msisdn: string, suscriptionType: string, idPlan: string) {
    return this.serviceCallUtilsService.callPostWebService(
      constants.ENDPOINT_BALANCES_AND_BOLTON,
      { "msisdn": msisdn, "suscriptionType": suscriptionType, "idPlan": idPlan }
    );
  }

  /**
  * Description: Método que llama el servicio web de obtener datos al equipo de linea
  * Autor: Angel Marin
  * @param msisdn identificador de la cuenta
  * @return Mensaje de confirmación de la validación
  */
  getEquipment(msisdn: string) {
    return this.serviceCallUtilsService.callSecuredPostWebService(
      constants.ENDPOINT_GET_IMEI_LINES,
      { "identificationValue": msisdn }
    );
  }

  /**
  * Description: Método que llama el servicio web de obtener datos al equipo de linea
  * Autor: Angel Marin
  * @param codeSuscription identificador de la cuenta
  * @return Objeto con la informacion del combo recurrente
  */
  getPaymentMethodFavorita(codeSuscription: string) {
    return this.serviceCallUtilsService.callSecuredPostWebService(
      constants.ENDPOINT_GET_PAYMENTMETHODFAVORITA,
      { "codeSuscription": codeSuscription }
    );
  }


  /**
  * Description: Método que llama el servicio web de obtener datos al equipo de linea
  * Autor: Angel Marin
  * @param msisdn identificador de la cuenta
  * @return Mensaje de confirmación de la validación
  */
  cancelComboRecurrentFavorita(codeSuscription: string) {
    return this.serviceCallUtilsService.callSecuredPostWebService(
      constants.ENDPOINT_POST_UNSUBSCRIBEFAVORITA,
      { "codeSuscription": codeSuscription }
    );
  }

    /**
  * Description: Método que llama el servicio web de obtener de la facturacion
  * Autor: Angel Marin
  * @param msisdn identificador de la cuenta
  * @return Mensaje de confirmación de la validación
  */
 getBillingFavorita(codeSuscription: string) {
  return this.serviceCallUtilsService.callSecuredPostWebService(
    constants.ENDPOINT_POST_FINDINVOICESFAVORITA,
    { "codeSuscription": codeSuscription,
      "totalRecords":constants.NUMBER_10 
    }
  );

}


    /**
  * Description: Método que llama el servicio web de obtener de la facturacion
  * Autor: Angel Marin
  * @param msisdn identificador de la cuenta
  * @return Mensaje de confirmación de la validación
  */
 getDocumentFormat(data: any) {
  return this.serviceCallUtilsService.callSecuredPostWebService(
    constants.ENDPOINT_POST_FINDDATAINVOICEFAVORITA
    ,
    { "keyAccessSRI":  data.keyAccessSRI,
      "codeSuscription": data.codeDocument ,
      "totalValue": data.totalValue.replace('$', '').replace('.', '').replace(',', '.').trim()
    }
  );

}



 


  /**
   * Description: Método que llama el servicio web de obtener las tarifas
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getRateList() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_RATES_LIST, { "category": constants.CATEGORY_RATES_ALL });
  }


    
  /**
   * Description: Método que llama el servicio web de obtener sla configuracion de recurrencia, si es encendido o apagado
   * Autor: Diego Diaz
   * @param N/A
   * @return Swtich true(encendido) o false(apagado)
   */
  getRecurrenceEnableConfig() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_SWITCH_RECURRENCE_CONFIG, "");
  }


}
